/**
 * Action kind: soldout.
 *
 * Deliberately renders NOTHING — no button, no link, nothing clickable.
 *
 * Note this is not the same as core's "Out of stock", which is a stock *label*
 * that can still sit above a live Add to Cart button when
 * settings.allow_items_not_in_stock is on. This kind means there is no
 * purchase path at all, so the actions slot stays empty and the stock line
 * carries the message.
 */

export function render() {
	return null;
}
